import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
} from '@floating-ui/vue'
import { onClickOutside } from '@vueuse/core'

import type { CSSProperties, Ref } from 'vue'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import { faEllipsisVertical, faTrash } from '@fortawesome/pro-regular-svg-icons'

import { useKidStore } from './store'

interface KidActionsReturn {
  isOpen: Ref<boolean>
  containerRef: Ref<HTMLElement | null>
  floatingRef: Ref<HTMLElement | null>
  floatingStyles: Ref<CSSProperties>
  triggerIcon: IconDefinition
  deleteIcon: IconDefinition
  toggle: () => void
  openDelete: () => void
}

export const useKidActions = (): KidActionsReturn => {
  const kidStore = useKidStore()

  const isOpen = ref(false)
  const containerRef = ref<HTMLElement | null>(null)
  const floatingRef = ref<HTMLElement | null>(null)

  const { floatingStyles } = useFloating(containerRef, floatingRef, {
    placement: 'bottom-end',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(4),
      flip(),
      shift({ padding: 8 }),
    ],
  })

  const toggle = (): void => {
    isOpen.value = !isOpen.value
  }

  const openDelete = (): void => {
    isOpen.value = false
    kidStore.setModalDelete(true)
  }

  onClickOutside(containerRef, () => {
    isOpen.value = false
  })

  return {
    isOpen,
    containerRef,
    floatingRef,
    floatingStyles,
    triggerIcon: faEllipsisVertical,
    deleteIcon: faTrash,
    toggle,
    openDelete,
  }
}
